module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-container"
  }, [_c('div', {
    attrs: {
      "id": "country-list"
    }
  }, [_c('ul', {
    staticClass: "map-list"
  }, _vm._l((_vm.countries), function(item, index) {
    return _c('li', [(item.Euro === '1') ? _c('a', {
      class: ['icon flag-' + item.ID, item.isactive ? _vm.activeClass : ''],
      attrs: {
        "href": "#info"
      },
      on: {
        "click": function($event) {
          _vm.onListClick(index, item, $event)
        }
      }
    }, [_vm._v(_vm._s(item.Land))]) : _vm._e()])
  })), _vm._v(" "), (_vm.view === 'comparison') ? _c('CheckBox', {
    staticClass: "hide-m",
    attrs: {
      "id": "Alle Länder auswählen",
      "name": "grp-all",
      "isDisabled": false,
      "checked": _vm.allCountriesSelected,
      "action": "selectAllCountries"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "hide-s",
    attrs: {
      "id": "europe-map"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('a', {
    staticClass: "icon-zoom-out",
    attrs: {
      "href": "#",
      "title": "Karte verkleinern"
    },
    on: {
      "click": function($event) {
        _vm.zoomOut($event)
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "icon-zoom-in",
    attrs: {
      "href": "#",
      "title": "Karte vergrößern"
    },
    on: {
      "click": function($event) {
        _vm.zoomIn($event)
      }
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "labels"
  }, [_c('div', {
    staticClass: "has-euro"
  }, [_vm._v("Euroländer")]), _vm._v(" "), _c('div', {
    staticClass: "has-no-euro"
  }, [_vm._v("EU-Länder, die nicht"), _c('br'), _vm._v(" den Euro als Währung haben")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3946a3df","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/Map.vue
// module id = 565
// module chunks = 0